<template>

  <div class="view pa24">
    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center">
            <el-input v-model="queryParam.excleCode" class="mb10" style="width: 240px" placeholder="请输入订单号"></el-input>
            <el-input v-model="queryParam.name" class="mb10 ml10" style="width: 240px" placeholder="请输入名称"></el-input>
            <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>
            <el-button class="ml10 mb10" type="primary" @click="reset">重置</el-button>
            <el-button type="primary mb10" @click="addboug">新增任务计划</el-button>
            <el-button class="ml10 mb10" type="primary" @click="openImport">导入订单</el-button>
            <el-button type="primary mb10" @click="addPurchase">生成采购清单</el-button>
            <el-button type="primary mb10" @click="outbound">生成出库单</el-button>
            <el-button type="primary mb10" icon="Download" @click="syncSuplier">同步供应商信息</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.excleDetails">
            <el-table-column prop="homeCode" align="center" label="作业编号" />
            <el-table-column prop="name" align="center" label="名称" />
            <el-table-column prop="partNumber" align="center" label="型号规格" />
            <el-table-column prop="drawing" align="center" label="图号" />
            <el-table-column prop="num" align="center" label="所需数量" />
            <el-table-column prop="unit" align="center" label="单位" />
            <el-table-column prop="orderCompany" align="center" label="订购单位" />
            <el-table-column prop="mold" align="center" label="组件类型">
              <template slot-scope="scope">
                <!-- 1-产品 2-组件 3-零件 -->
                <template v-if="scope.row.mold == 1">产品</template>
                <template v-if="scope.row.mold == 2">组件</template>
                <template v-if="scope.row.mold == 3">零件</template>
              </template>
            </el-table-column>
            <el-table-column prop="contract" align="center" label="合同号" />
            <el-table-column prop="delivery" align="center" label="交货日期" />
            <el-table-column prop="remark" align="center" label="编号/备注" />
            <el-table-column prop="invoicing" align="center" label="是否开票">
              <template slot-scope="scope">
                <template v-if="scope.row.invoicing == 0">否</template>
                <template v-if="scope.row.invoicing == 1">是</template>
              </template>
            </el-table-column>
            <el-table-column prop="sale" align="center" label="销售人员" />
            <el-table-column prop="quantities" align="center" label="需补充数量" />
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="excleCode" align="center" label="订单编号" />
      <el-table-column prop="name" align="center" label="名称" />
      <el-table-column prop="scheduleDate" align="center" label="计划下单日期" />
      <el-table-column prop="serial" align="center" label="序号" />
      <el-table-column prop="prepared" align="center" label="编制人" />
      <el-table-column prop="approver" align="center" label="批准人" />
      <el-table-column prop="examined" align="center" label="审批人" />
      <el-table-column prop="status" align="center" label="出库单状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 0" type="info"
            style="background-color: #f4f4f5; color: #909399;">没有</el-tag>
          <el-tag v-if="scope.row.status == 1" type="info" style="background-color: #e6a23c; color: #fff;">临时</el-tag>
          <el-tag v-if="scope.row.status == 2" type="info" style="background-color: #67c23a; color: #fff;">完成生产</el-tag>
          <el-tag v-if="scope.row.status == 3" type="success"
            style="background-color: #409eff; color: #fff;">完整</el-tag>
          <el-tag v-if="scope.row.status == 4" type="success"
            style="background-color: #409eff; color: #fff;">已出库</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="purchaseStatus" align="center" label="采购单状态">
        <template slot-scope="scope">

          <el-tag v-if="scope.row.purchaseStatus == 0" type="info" style="background-color: #f56c6c; color: #fff;">
            待生成
          </el-tag>

          <el-tag v-else-if="scope.row.purchaseStatus == 1" type="success"
            style="background-color: #67c23a; color: #fff;">
            已生成
          </el-tag>

          <el-tag v-else-if="scope.row.purchaseStatus == 2" type="success"
            style="background-color: #409eff; color: #fff;">
            已完成
          </el-tag>

          <el-tag v-else-if="scope.row.purchaseStatus == 3" type="info" style="background-color: #909399; color: #fff;">
            无需采购
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" align="center" label="备注：操作人" />
      <!-- <el-table-column prop="createTime" align="center" label="创建时间" /> -->
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="completePurchases(scope.row)"
            v-if="scope.row.purchaseStatus==1 || scope.row.purchaseStatus==0">采购清单</el-button>
          <el-button type="text" @click="process(scope.row)" v-if="scope.row.purchaseStatus==2">流程清单</el-button>
          <el-popconfirm confirm-button-text=" 确定" cancel-button-text="取消" @confirm="handleDelBom(scope.row.id)"
            icon="el-icon-info" icon-color="red" title="确定要删除吗？">
            <!-- 刷新状态的按钮 -->
            <el-button slot="reference" class="ml10" style="color: #fd634e" type="text">删除</el-button>
          </el-popconfirm>
          <el-button type="text" class="ml10" @click="refresh(scope.row)">刷新状态</el-button>
          <!-- 确认出库 -->
          <el-button type="text" class="ml10" @click="openOutboundDialog(scope.row)"
            v-if="scope.row.excleDetails.some(item => item.isOut !== 1)">
            确认出库
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>
    <!-- 导入订单 -->
    <el-dialog title="导入订单" :visible.sync="dialogFormVisible1" append-to-body :close-on-click-modal="false">
      <el-form :model="form" label-width="80px">
        <el-upload ref="upload" class="upload-demo" :headers="upParams" drag :action="uploadUrl"
          :on-exceed="handleExceed" :on-error="handleError" :on-success="handleSuccess" multiple accept=".xls,.xlsx"
          :auto-upload="false">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submitUpload">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 同步供应商 -->
    <el-dialog title="供应商同步" :visible.sync="dialogFormVisible2" append-to-body :close-on-click-modal="false">
      <el-form v-model="syncForm" label-width="80px">
        <el-form-item label="账号">
          <el-input v-model="syncForm.userName"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="syncForm.password" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="syncData">同 步</el-button>
      </div>
    </el-dialog>
    <!-- 待确认事项对话框 -->
    <el-dialog title="待确认事项" :visible.sync="confirmItemDialogVisible" append-to-body :close-on-click-modal="false"
      width="600px">
      <el-table :data="itemsWithoutRemark" style="width: 100%">
        <el-table-column prop="name" label="名称" align="center" />
        <!-- 型号规格 -->
         <el-table-column prop="partNumber" label="型号规格" align="center" />
        <el-table-column prop="remark" label="编号/备注" align="center" />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirmItemDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="goToOutbound">去出库</el-button>
      </div>
    </el-dialog>

    <!-- 确认出库对话框 -->
    <el-dialog title="确认出库" :visible.sync="outboundDialogVisible" append-to-body :close-on-click-modal="false"
      custom-class="outbound-dialog" width="42%">
      <!-- 只渲染有 items 的 typeData -->
      <div v-for="(typeData, index) in containerData.filter(data => data.items.length > 0)" :key="index"
        class="type-section">
        <h3 class="type-title">{{ typeData.typroductName }}</h3>
        <!-- 新增备注输入框 -->
        <div class="remark-input">
          <label>备注：</label>
          <el-input v-model="typeData.remark" placeholder="请输入备注信息"></el-input>
        </div>

        <el-table :data="typeData.items" style="width: 100%"
          @selection-change="(selection) => handleItemSelect(selection, index)" :selectable="(row) => row.isOut !== 1">
          <el-table-column type="selection" width="55" align="center" :selectable="row => row.isOut !== 1" />
          <el-table-column prop="name" label="产品名称" width="200">
            <template slot-scope="scope">
              <div v-for="(code, idx) in scope.row.codeList" :key="idx">
                {{ code.detailName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="容器码" width="250">
            <template slot-scope="scope">
              <div v-for="(code, idx) in scope.row.codeList" :key="idx">
                {{ code.name }}({{ code.handle }})
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="剩余数量" width="120" align="center">
            <template slot-scope="scope">
              <div v-for="(code, idx) in scope.row.codeList" :key="idx">
                {{ code.num }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="isOut" label="是否出库" width="100" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.isOut === 1 ? '是' : '否' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outboundDialogVisible = false" class="cancel-btn">取 消</el-button>
        <el-button type="primary" @click="confirmOutbound" class="confirm-btn">出 库</el-button>
      </div>
    </el-dialog>



    <AddPurchaseDialog ref="addPurchaseDialog" @getList="getList"></AddPurchaseDialog>
    <OutboundDialog ref="outboundDialog" @getList="getList"></OutboundDialog>
    <!-- 新增弹窗 -->
    <addboudDialog ref="addboudDialog" @success="handleAddbound"></addboudDialog>
    <!-- 绑定经销商 -->
    <!-- <bindDealerDialog ref="bindDealerDialog" @success="handleDearlar"></bindDealerDialog> -->
    <!-- 采购单 -->
    <completePurchasesDialog ref="completePurchasesDialog" @getList="getList"></completePurchasesDialog>
    <!-- 流程清单 -->
    <processDialog ref="processDialog"></processDialog>
  </div>
</template>
<script>
  import { add, edit, query, queryList, delOrder, completePurchase, syncDealer, taskProcess, listByType, outStock, getContainerCode, queryProduct, updatePurchaseStatus } from '@/api/boomClass.js'
  import AddPurchaseDialog from './component/AddPurchaseDialog'
  import OutboundDialog from './component/OutboundDialog'
  import addboudDialog from './component/addboudDialog'
  // import bindDealerDialog from './component/bindDealerDialog'
  import completePurchasesDialog from './component/completePurchasesDialog'
  import processDialog from './component/processDialog'
  export default {
    components: {
      AddPurchaseDialog,
      OutboundDialog,
      addboudDialog,
      // bindDealerDialog,
      completePurchasesDialog,
      processDialog
    },
    props: {

    },
    data() {
      let token = localStorage.getItem("token")

      return {
        remark: '',

        upParams: {
          token: token
        },
        syncForm: {
          userName: '',
          password: ''
        },
        queryParam: {
          name: '',
        },
        uploadUrl: '/api/api/boomExcle/importExcel',
        dialogFormVisible1: false,
        dialogFormVisible2: false,
        name: null,
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        excleType: '',
        form: {
        },

        rules: {
        },
        outboundDialogVisible: false,
        confirmItemDialogVisible: false,
        itemsWithoutRemark: [],
        currentRow: null,
        containerData: [],
        selectedItems: [],
        // 新增存储选中信息的对象
        selectedInfo: []
      };
    },
    created() {
      this.getList()
    },
    methods: {
      refresh(row) {
        queryProduct({
          excelId: row.id
        }).then(res => {
          if (res.data == 1) {
            // 提示更新成功
            this.$message({
              type: 'success',
              message: '更新成功'
            })
            this.getList()
          } else {
            this.$message({
              type: 'error',
              message: '更新失败'
            })
            this.getList()
          }
        })
      },
      reset() {
        this.queryParam = {}
        this.getList()
      },
      // changeDealer(item) {
      //   this.$refs.bindDealerDialog.open(item.id)
      // },
      addboug() {
        this.$refs.addboudDialog.open()
      },
      completePurchases(row) {
        this.$refs.completePurchasesDialog.open(row)
      },
      process(row) {
        this.$refs.processDialog.open(row)
      },
      handleAddbound() {
        this.getList()
      },
      handleDearlar() {
        this.getList()
      },
      load(tree, treeNode, resolve) {
        setTimeout(() => {
          let params = {
            noPage: true,
            type: this.classType,
            name: this.name,
            specName: this.specName,
            partNumber: this.partNumber,
            classType: 0,
            status: this.storeStatus,
            parentId: tree.id
          }
          queryList(params).then(res => {
            resolve(res.data.list)
          })
        }, 1000)
      },
      getCustomer() {
        this.getList()
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        params = Object.assign(params, this.queryParam)
        queryList(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
      toForm(type, data) {
        if ('add' == type) {
          this.dialogFormVisible = true
        } else if ('edit' == type) {
          this.form = data
          this.dialogFormVisible = true
        }
      },
      submitForm() {
        addCodePrint(this.form).then(res => {
          this.$nextTick(() => {
            this.$refs.form.resetFields()
          })
          this.$message.success("操作成功")
          this.getList()
          this.dialogFormVisible = false
        })
      },
      handleDelBom(id) {
        delOrder(id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getList()
        })
      },


      syncSuplier() {
        this.dialogFormVisible2 = true
      },
      syncData() {
        let param = {
          userName: this.syncForm.userName,
          password: this.syncForm.password
        }
        syncDealer(param).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '同步成功!'
            });
            this.getList()
            this.dialogFormVisible2 = false
          } else {
            this.$message.error("账号或者密码有误！")
          }
        })
      },
      handleSuccess(response, file, fileList) {
        if (response.code != 200) {
          this.$message.error(response.message)
          this.$refs.upload.clearFiles();
        } else {
          this.$message.success("导入成功")
          this.getList()
          this.dialogFormVisible1 = false
        }
      },
      addPurchase() {
        this.$refs.addPurchaseDialog.openDialog()
      },
      outbound() {
        this.$refs.outboundDialog.openDialog()
      },
      openImport() {
        this.dialogFormVisible1 = true
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      handleError(err, file, fileList) {
        this.$message.error("导入失败")
      },
      handleExceed(files, fileList) {
        this.$message.warning("只能上传1个文件");
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      openOutboundDialog(row) {
        console.log(row)
        this.currentRow = row
        
        // 检查是否有产品有备注
        const itemsWithRemark = row.excleDetails.filter(item => item.remark && item.remark.trim() !== '')
        
        // 如果都没有备注，直接显示确认出库弹窗
        if (itemsWithRemark.length === 0) {
          this.showOutboundDialog()
          return
        }
        
        // 只要有一个产品有备注，显示待确认事项弹窗，只展示有备注的产品
        this.itemsWithoutRemark = itemsWithRemark.map(item => ({
          name: item.name,
          remark: item.remark,
          partNumber:item.partNumber
        }))
        this.confirmItemDialogVisible = true
      },
      
      goToOutbound() {
        this.confirmItemDialogVisible = false
        this.showOutboundDialog()
      },
      
      showOutboundDialog() {
        this.outboundDialogVisible = true
        this.selectedItems = []
        // 初始化容器数据
        this.containerData = [
          {
            typeName: '产品',
            items: []
          },
          {
            typroductName: '组件',
            items: []
          },
          {
            typeName: '零件',
            items: []
          }
        ]

        if (this.currentRow.excleDetails && this.currentRow.excleDetails.length > 0) {
          let classIds = this.currentRow.excleDetails.map(d => d.classId);

          getContainerCode({ excleIds: classIds }).then(res => {
            const data = res.data || [];

            const mergedData = data.map(item => {
              const matchedDetail = this.currentRow.excleDetails.find(d => d.classId === item.classId);
              console.log(matchedDetail);
              return {
                ...item,
                isOut: matchedDetail ? matchedDetail.isOut : 0,// 默认为0
                detailName: matchedDetail ? matchedDetail.name : 0,
              };
            });


            this.currentRow.excleDetails.forEach(detail => {
              const codeList = mergedData.filter(item => item.classId === detail.classId);
              const newItem = {
                id: detail.id,
                productName: detail.name,
                partNumber: detail.partNumber,
                isOut: detail.isOut,
                codeList
              };

              const targetType = this.getTargetType(codeList[0]?.type);
              if (targetType) {
                targetType.items.push(newItem);
              }
            });

            this.containerData.forEach(typeData => {
              typeData.items = typeData.items.filter((item, index, self) =>
                index === self.findIndex(t => t.id === item.id)
              );
            });
            this.containerData = this.containerData.filter(t => t.items.length > 0);

            console.log("最终 containerData", this.containerData);
          });
        } else {
          getContainerCode({ excleId: this.currentRow.id }).then(res => {
            const data = res.data || []
            this.containerData = [
              {
                typeName: '产品',
                items: data.filter(item => item.type === 0).map(item => ({ ...item, productName: '' }))
              },
              {
                typeName: '组件',
                items: data.filter(item => item.type === 1).map(item => ({ ...item, productName: '' }))
              },
              {
                typeName: '零件',
                items: data.filter(item => item.type === 2).map(item => ({ ...item, productName: '' }))
              }
            ].map(typeData => {
              // 去重处理
              typeData.items = typeData.items.filter((item, index, self) =>
                index === self.findIndex(t => t.id === item.id)
              )
              return typeData
            })
          })
        }
      },
      // 辅助方法，根据 type 获取对应的 containerData 项
      getTargetType(type) {
        switch (type) {
          case 0:
            return this.containerData[0]
          case 1:
            return this.containerData[1]
          case 2:
            return this.containerData[2]
          default:
            return null
        }
      },

      // 新增选中处理方法
      handleItemSelect(selection, typeIndex) {
        // console.log("选中的项目:", selection);
        // 清空之前该类型的数据
        // this.selectedInfo[typeIndex] = selection.map(item => ({
        //   storeCodeId: item.id,
        //   classId: item.classId,
        // }));
        // 添加新选中的数据
        selection.forEach(item => {
          // console.log(item);
          item.codeList.forEach(code => {
            this.selectedInfo.push({
              storeCodeId: code.id,
              classId: code.classId,
            });
          })
          // this.selectedInfo.push({
          //   storeCodeId: item.id,
          //   classId: item.classId,
          // });
        });
        // this.selectedInfo.flat();

        console.log("选中信息:", this.selectedInfo);
      },

      confirmOutbound() {
        if (this.selectedInfo.length === 0) {
          this.$message.warning('请选择要出库的项目');
          return;
        }

        console.log('选中信息:', this.selectedInfo);
        const allRemarks = this.containerData.map(typeData => typeData.remark);
        console.log(allRemarks);

        // 提取唯一的选择项（避免重复）
        const uniqueSelection = this.selectedInfo.filter((item, index, self) =>
          index === self.findIndex(t => t.storeCodeId === item.storeCodeId)
        );

        let params = {
          excleId: this.currentRow.id,
          remark: allRemarks.join('; '),
          outStockDetailDtoList: uniqueSelection.map(item => ({
            storeCodeId: item.storeCodeId,
            classId: item.classId
          }))
        };

        console.log(params);
        outStock(params).then(res => {
          if (res.code != 200) {
            this.$message.error(res.message);
            return;
          }
          this.outboundDialogVisible = false;
          this.$message.success('出库操作已确认');
          this.getList();
        });
      }
    },
  }
</script>
<style scoped>
  .pageBox {
    display: flex;
    justify-content: flex-end;
  }

  .blue {
    color: #51CBCD;
    cursor: pointer;

  }

  .outbound-dialog {
    width: 80%;
    /* 调整对话框宽度 */
    max-width: 800px;
    /* 最大宽度 */
  }

  .type-section {
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    background-color: #f9f9f9;
  }

  .type-title {
    color: #333;
    font-size: 18px;
    margin-bottom: 10px;
  }

  .product-item {
    margin-bottom: 15px;
    padding: 10px;
    background-color: #fff;
    border: 1px solid #eee;
    border-radius: 4px;
  }

  .product-name {
    color: #666;
    font-size: 16px;
    margin-bottom: 8px;
  }

  .radio-group {
    color: #444;
    font-size: 14px;
  }

  .radio-item {
    margin-right: 15px;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }

  .cancel-btn {
    margin-right: 10px;
  }

  .confirm-btn {
    min-width: 100px;
  }

  .remark-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .remark-label {
    white-space: nowrap;
    margin-right: 10px;
  }

  .remark-input {
    flex: 1;
  }
</style>